export const MULTI_PRODUCT_ROUTES = {
    ECOMMERCE: "/miecommerce",
    RANKING: "/posicionamiento",
    MANAGEMENT_SUMMARY: "/miresumengerencial",
    ASSORTMENT: "/assortment",
    MARKETPLACE: "/mimarketplace",
    PRODUCTOS: "/misproductos",
    CUSTOMER_REPORT: "/reporte-salud-clientes",
};
